import React from 'react';

const Welcome = () => {
    return (
        <div>
                     <h2 className='text-3xl font-bold text-primary text-center'>Welcome to my Dashboard Page</h2>

        </div>
    );
};

export default Welcome;